<div class="card stat-card h-100">
  <div class="card-body">
    <div class="d-flex align-items-start">
      <div class="stat-card-icon" [ngClass]="'bg-' + iconColor + '-subtle'">
        <lucide-icon [name]="icon" [ngClass]="'text-' + iconColor"></lucide-icon>
      </div>
      <div class="flex-grow-1 ms-3">
        @if (!loading) {
          <h3 class="stat-card-value mb-1">{{ value }}</h3>
          <p class="stat-card-label text-muted mb-0">{{ label | translate }}</p>
        } @else {
          <div class="placeholder-glow">
            <span class="placeholder col-6 placeholder-lg"></span>
            <span class="placeholder col-8 mt-2"></span>
          </div>
        }
      </div>
    </div>
    @if (trend !== null && !loading) {
      <div class="stat-card-trend mt-3">
        <span [class]="trendClass">
          <lucide-icon [name]="trendIcon" class="stat-card-trend-icon"></lucide-icon>
          {{ formattedTrend }}
        </span>
        @if (trendLabel) {
          <span class="text-muted ms-1">{{ trendLabel | translate }}</span>
        }
      </div>
    }
  </div>
</div>
